/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 乗務員毎週次乗務
 * @export
 * @interface WeeklyShiftsDriverRequest
 */
export interface WeeklyShiftsDriverRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof WeeklyShiftsDriverRequest
     */
    officeId?: number;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof WeeklyShiftsDriverRequest
     */
    driverId?: number;
    /**
     * week_number
     * @type {number}
     * @memberof WeeklyShiftsDriverRequest
     */
    weekNo?: number;
    /**
     * year_number
     * @type {number}
     * @memberof WeeklyShiftsDriverRequest
     */
    year?: number;
    /**
     * multiple営業所で検索のためのリスト
     * @type {Array<number>}
     * @memberof WeeklyShiftsDriverRequest
     */
    officeIds?: Array<number>;
}

export function WeeklyShiftsDriverRequestFromJSON(json: any): WeeklyShiftsDriverRequest {
    return WeeklyShiftsDriverRequestFromJSONTyped(json, false);
}

export function WeeklyShiftsDriverRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyShiftsDriverRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'weekNo': !exists(json, 'week_no') ? undefined : json['week_no'],
        'year': !exists(json, 'year') ? undefined : json['year'],
        'officeIds': !exists(json, 'office_ids') ? undefined : json['office_ids'],
    };
}

export function WeeklyShiftsDriverRequestToJSON(value?: WeeklyShiftsDriverRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'driver_id': value.driverId,
        'week_no': value.weekNo,
        'year': value.year,
        'office_ids': value.officeIds,
    };
}


